import { apiGet } from '../../api'

export const get_group = data => {
  let query = data.id ? `id=${data.id}` : ''

  return apiGet({
    endpoint: `groups/get_group?${query}`
  })
}
